import { LitElement, html, utils, css } from '@hh/global.js';
const { prefersReducedMotion } = utils

class HHDrawer extends LitElement {
  static properties = {
    _trapFocus: {
      state: true,
    },
    _open: {
      state: false
    }
  }

  constructor() {
    super()

    this.handleBodyClick = this.handleBodyClick.bind(this)

    document.addEventListener('openDrawer', (e) => { this.open(e) })
    this.querySelectorAll(".js-additional-close")?.forEach((el) => {
      el.addEventListener('click', this.close)
    })

    document.addEventListener('keydown', (e) => {
      if (document.body.classList.contains("mobile-menu-open") && e.code.toUpperCase() == 'ESCAPE') {
        document.querySelector("hh-drawer[data-drawer='mobile-menu']").close()
      } else if (e.code.toUpperCase() == 'ESCAPE' && this.closest('.drawer').classList.contains('drawer-is-active')) {
        this.close()
      }
    })
  }

  connectedCallback() {
    super.connectedCallback()
    document.body.addEventListener('click', this.handleBodyClick)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    document.body.removeEventListener('click', this.handleBodyClick)
  }

  handleBodyClick(e) {
    // Keep the 3D drawer open while interacting with the AR modal
    const threeDDrawer = document.querySelector('[data-drawer="3d-ar"]');
    const arModal = document.querySelector('.js-ar-modal');
    if (this === threeDDrawer && arModal?.classList.contains('drawer-is-active')) {
      return;
    }

    // Keep mobile menu open if clicking inside the orbe modal
    const orbeModal = document.querySelector('#md-app-embed__modal');
    if (orbeModal && orbeModal.contains(e.target)) {
      return;
    }

    if ((!this.contains(e.target) && this._open && !this.trigger.contains(e.target)) || e?.code?.toUpperCase() === 'ESCAPE') {
      this.close()
    }
  }

  open(e) {
    if (e.detail.key == this.dataset.drawer) {
      this.trigger = e.target?.closest('.js-drawer-trigger');
      
      if (this._open) {
        this.close()
        return
      }

      if (e.detail.key.indexOf('store') > -1) {
        document.body.classList.add('scroll-lock-mobile');
      } else {
        document.body.classList.add('scroll-lock');
      }
      if (e.detail.key != 'media-zoom' && e.detail.key != 'search' && e.detail.key.indexOf('store') < 0) {
        document.querySelector('.js-overlay').classList.add('active')
        if (this.dataset.drawer === 'ar-modal') {
          document.querySelector('.js-overlay').classList.add('overlay-secondary');
        }
      }

      if (e.detail.key == 'media-zoom') { 
        document.querySelector('.js-product-media-zoom').moveTo(e.detail.index - 1, 'instant')
      }
      
      this.closest('.drawer').classList.add('drawer-is-active')
      this._open = true

      if (!prefersReducedMotion()) {
        document.querySelectorAll('hh-vertical-carousel').forEach(el => el.pause())
      }

      if (e.detail.key == "mobile-menu") {
        document.body.classList.add('mobile-menu-open')
      }

      if (e.detail.key == "search") {
        setTimeout(() => {
          document.querySelector("#search-id").focus()
        }, 100)
      }

      if (e.detail.key.indexOf('store') > -1 && window.pageHandle) {
        // Wait for open drawer to close first
        setTimeout(() => {
          this.trigger.classList.add('active')
          const store = e.detail.key.split('--')[1]
          const region = e.target?.dataset?.region || window.location.href.split(window.pageHandle)[1].split('--')[0].replace('/', '')
          const url = window.location.href.split(window.pageHandle)[1] == '' ? `${window.pageHandle}/${region}--${store}` : `${region}--${store}`
          window.history.pushState({}, '', url)
        }, 0);
      }

      if (e.detail.key === '3d-ar' || e.detail.key === 'ar-modal') {
        setTimeout(() => {
          this.querySelector('.js-focus-entry').focus();
        }, 100)
      }
    }
  }

  close(e) {
    e?.preventDefault()

    if (this.dataset.drawer !== 'ar-modal') {
      document.body.classList.remove('scroll-lock', 'scroll-lock-mobile', 'mobile-menu-open');
    }
    document.querySelector('.js-overlay').classList.remove('active')
    if (this.dataset.drawer === 'ar-modal') {
      document.querySelector('.js-overlay').classList.remove('overlay-secondary');
    }

    this.closest('.drawer').classList.remove('drawer-is-active')
    this._open = false
    if (!prefersReducedMotion()) {
      document.querySelectorAll('hh-vertical-carousel').forEach(el => el.play())
    }

    document.querySelectorAll('.js-drawer-trigger').forEach(el => el.classList.remove('active'))

    setTimeout(() => {
      this.trigger.shadowRoot?.querySelector('button').focus();
    }, 100)
  }

  render() {
    return html`<div role="dialog"
      aria-modal="true"
      @keyup="${this.handleBodyClick}"
      style="height: 100%;">
      <hh-focus-trap active="true">
        <slot name="close" @click="${this.close}"></slot>
        <slot
          name="body"
          style="height: 100%;"
        ></slot>
      </hh-focus-trap>
    </div> `
  }

  static styles = [
    css`
      :host([data-drawer='gift-wrapping']) div {
        height: auto !important;
      }
    `
  ]
}

customElements.define('hh-drawer', HHDrawer)
